import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import StyledVideo from "components/Styled/Video";
import {
  PRO_IMAGE_PREVIEW_LINK,
  PRO_IMAGE_PREVIEW_LINK_SQUARE,
  PRO_SUBSCRIPTION_VIDEO_LINK,
  VA_IMAGE_PREVIEW_LINK,
  VA_SUBSCRIPTION_VIDEO_LINK,
} from "constants/influencer";

const HomeVideo = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription } = useContext(SubscriptionContext);

  if (currentOrg?.isVaUser) {
    return (
      <StyledVideo
        image={VA_IMAGE_PREVIEW_LINK}
        videoPreview={VA_IMAGE_PREVIEW_LINK}
        link={VA_SUBSCRIPTION_VIDEO_LINK}
        title={"Make the Most of Your Virtual Assistant Subscription"}
      />
    );
  } else if (
    subscription?.subscription?.planName &&
    subscription?.isSubscribed &&
    [Plans.PRO, Plans.PRO_YEARLY]?.includes(
      subscription?.subscription?.planName,
    )
  ) {
    return (
      <StyledVideo
        image={PRO_IMAGE_PREVIEW_LINK_SQUARE}
        videoPreview={PRO_IMAGE_PREVIEW_LINK}
        link={PRO_SUBSCRIPTION_VIDEO_LINK}
        title={"Make the Most of Your Pro Subscription"}
        widthPercentage={30}
      />
    );
  } else {
    return <></>;
  }
};

export default HomeVideo;
